const TOKEN_KEY = "nolags_admin_token";

// Ошибка API с распарсенным телом. Раньше кидали голый Error(status+text) → фронт
// не мог достать structured detail (напр. 409 has_active_subscriptions) и показывал
// сырой JSON вместо диалога. Теперь detail/body/status доступны обработчику.
export class ApiError extends Error {
  status: number;
  body: unknown;
  detail: unknown;
  constructor(status: number, body: unknown, raw: string) {
    let detail: unknown = undefined;
    if (body && typeof body === "object" && "detail" in (body as Record<string, unknown>)) {
      detail = (body as Record<string, unknown>).detail;
    }
    const msg =
      typeof detail === "string"
        ? detail
        : detail && typeof detail === "object" && "message" in (detail as Record<string, unknown>)
          ? String((detail as Record<string, unknown>).message)
          : `${status} ${raw}`;
    super(msg);
    this.name = "ApiError";
    this.status = status;
    this.body = body;
    this.detail = detail;
  }
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string | null): void {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const token = getToken();
  const headers = new Headers(init.headers);
  // Для FormData заголовок ставит браузер сам (с boundary) — иначе multipart ломается.
  if (!(init.body instanceof FormData)) headers.set("Content-Type", "application/json");
  if (token) headers.set("Authorization", `Bearer ${token}`);

  const r = await fetch(path, { ...init, headers });
  if (r.status === 401 || r.status === 403) {
    setToken(null);
    throw new Error("unauthorized");
  }
  if (!r.ok) {
    const raw = await r.text();
    let body: unknown = raw;
    try {
      body = JSON.parse(raw);
    } catch {
      /* не JSON — оставляем текст */
    }
    throw new ApiError(r.status, body, raw);
  }
  return r.json() as Promise<T>;
}

export async function exchangeToken(token: string): Promise<{ access_token: string }> {
  const r = await fetch("/api/admin/auth/exchange", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token }),
  });
  if (!r.ok) throw new Error(`exchange failed: ${r.status} ${await r.text()}`);
  return r.json();
}
